import React from 'react';
import { motion } from 'framer-motion';
import { highlightTerms } from '../highlightTerms';
import { Target, Flame, Sparkles, Dumbbell } from 'lucide-react';

const icons = [Target, Flame, Sparkles, Dumbbell];

export const BentoSlide = ({ slide }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.12, delayChildren: 0.2 },
    },
  };

  const titleVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 40, scale: 0.95 },
    visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.5 } },
  };

  return (
    <div
      className="h-full w-full flex flex-col justify-center px-8 md:px-12 lg:px-20 py-12"
      data-testid={`slide-${slide.id}`}
    >
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="max-w-6xl mx-auto w-full"
      >
        <motion.h2
          variants={titleVariants}
          className="pres-font-heading text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white mb-12 text-center"
        >
          {highlightTerms(slide.title)}
        </motion.h2>

        <div className={`grid gap-6 ${slide.bullets?.length === 4 ? 'grid-cols-1 md:grid-cols-2' : 'grid-cols-1 md:grid-cols-3'}`}>
          {slide.bullets?.map((item, idx) => {
            const Icon = icons[idx % icons.length];
            return (
              <motion.div
                key={idx}
                variants={cardVariants}
                className="group relative bg-[#2A1D45]/50 backdrop-blur-md border border-white/10 rounded-2xl p-8 hover:border-[#D31113]/50 transition-all duration-300 hover:bg-[#2A1D45]/70 overflow-hidden"
              >
                <div className="absolute top-4 right-4 p-3 rounded-xl bg-[#D31113]/20 group-hover:bg-[#D31113]/40 transition-colors">
                  <Icon className="w-6 h-6 text-[#D31113]" />
                </div>
                <h3 className="pres-font-heading text-2xl md:text-3xl font-bold text-white uppercase mb-3">
                  {item.title}
                </h3>
                <p className="font-sans text-lg text-gray-300">
                  {highlightTerms(item.desc)}
                </p>
              </motion.div>
            );
          })}
        </div>

        {slide.keyLine && (
          <motion.div
            variants={cardVariants}
            className="mt-12 text-center"
          >
            <p className="font-sans text-xl md:text-2xl text-white font-semibold italic border-l-4 border-[#D31113] pl-6 inline-block text-left">
              "{highlightTerms(slide.keyLine)}"
            </p>
          </motion.div>
        )}
      </motion.div>
    </div>
  );
};
